import React, { Component } from "react";
import ProdCard from "../ProdCard/ProdCard";
import "./CustomizeSearchProds.css";

class CustomizeSearchProds extends Component {
	// Renders search product customization during onboarding
	render() {
		const tiles = this.props.searchProducts.map((s, index) => {
			return (
				<ProdCard
					info={s}
					addToOnboardingCart={this.props.addToOnboardingCart}
					key={index}
				/>
			);
		});
		return (
			<div className="customize-search-prods-container">
				{tiles}
			</div>
		);
	}
}

export default CustomizeSearchProds;


// WEBPACK FOOTER //
// ./src/components/SignUp/CustomizeSearchProds/CustomizeSearchProds.js